import React from "react";
import {URL} from "../ui/link";
import {Column, ColumnGrid} from "../ui/spectre/grid";
import translate from "../../../translate";

// noinspection SpellCheckingInspection
/**
 * @param membership {{ role: { isdefault, rolename, color }|null, group: { id, name, memberCount } }}
 * @returns {JSX.Element}
 * @constructor
 */
export function GroupMembershipCard({ membership }) {
    const { group, role } = membership;

    let roleName, roleColor = role === null ? 'inherit' : ('#' + role.color);
    switch(true) {
        case role === null:
            roleName = '-';
            break;
        default:
            roleName = role.rolename;
            break;
    }

    return <URL href={'/group/' + group.id} className={'group-container'}>
        <div>
            <div className={'group-name'}>{group.name}</div>

            <ColumnGrid className={'group-properties-container'}>
                <Column sizes={[6]}>
                    {translate('general/groups/group/role')}
                    <div className={'d-inline-block ml-1'} style={{ color: roleColor }}>
                        {roleName}
                    </div>
                </Column>
                <Column sizes={[6]}>
                    {translate('general/groups/group/member-count')} {group.memberCount ?? '-'}
                </Column>
            </ColumnGrid>
        </div>
    </URL>
}
